import Requestor from '@/api/Requestor';
import { clientInstance } from '@/api/core';
class TaxInvoiceApi extends Requestor {
    /**
     * 세금계산서 조회
     */
    getTaxInvoiceById(hubId, taxInvoiceId) {
        return this.get({
            url: `/api/v1/adjustment/hubs/${hubId}/tax-invoices/${taxInvoiceId}`,
        });
    }
    /**
     * 세금계산서 발행 전 정보 수정 (발행 후 에러)
     */
    putTaxInvoiceById(hubId, taxInvoiceId, data) {
        return this.put({
            url: `/api/v1/adjustment/hubs/${hubId}/tax-invoices/${taxInvoiceId}/invoicer`,
            data,
        });
    }
    /**
     * 세금계산서 발행
     */
    postTaxInvoiceToPublish(hubId, taxInvoiceId) {
        return this.post({
            url: `/api/v1/adjustment/hubs/${hubId}/tax-invoices/${taxInvoiceId}/publish`,
        });
    }
}
export default new TaxInvoiceApi(clientInstance);
